<template>
    <div>
    <h2 v-text="`${$props.tree.tree_name} Tree Structure`"></h2>
    <v-container class="fill-height" fluid style="padding: 0px;">
        <v-row>

        <v-col cols="12" md="6">
            <v-card>
                <v-card-text class="tree-body">
                    <v-treeview 
                        item-key="node_id" item-text="node_name" 
                        :items="[$props.tree.tree_structure]"
                        activatable
                        :multiple-active="false"
                        return-object
                        color="#ffffff"
                        dense
                        :open="openNodes"
                        @update:open="openedBranch"
                        :active.sync="selectedNodes">
                        <template v-slot:prepend="{ item }">
                            <v-icon v-text="`${item.node_line_height >= 1 ? 'mdi-leaf' : 'mdi-source-merge'}`" :style="{transform: `${item.node_line_height >= 1 ? 'none' : 'none'}`}"></v-icon>
                            <!-- <v-icon v-text="`${item.node_line_height >= 1 ? 'mdi-leaf' : ''}`"></v-icon> -->
                        </template>
                    </v-treeview>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="justify-center">
                    <v-btn class="mt-2 mb-2 ml-0 mr-2" color="#c42111" small fab :disabled="$props.lockSave || !selectedNodeBranch" @click="addBranch">
                        <v-icon style="transform: scaleX(-1);">mdi-keyboard-return</v-icon>
                    </v-btn>
                    <v-btn class="mt-2 mb-2 ml-2 mr-2" color="#c42111" small fab :disabled="$props.lockSave || !selectedNodeBranch" @click="addLeaf">
                        <v-icon>mdi-leaf</v-icon>
                    </v-btn>
                    <v-btn class="mt-2 mb-2 ml-2 mr-2" color="#c42111" small fab :disabled="$props.lockSave || !selectedNode || (selectedNode.node_id == -1) || isTop" @click="moveUp">
                        <v-icon>mdi-arrow-up-bold</v-icon>
                    </v-btn>
                    <v-btn class="mt-2 mb-2 ml-2 mr-2" color="#c42111" small fab :disabled="$props.lockSave || !selectedNode || (selectedNode.node_id == -1) || isBottom" @click="moveDown">
                        <v-icon>mdi-arrow-down-bold</v-icon>
                    </v-btn>
                    <v-btn class="mt-2 mb-2 ml-2 mr-2" color="#c42111" small fab :disabled="$props.lockSave ||!selectedNode" @click="copyNode">
                        <v-icon style="transform: scaleX(-1);">mdi-content-copy</v-icon>
                    </v-btn>
                    <v-btn class="mt-2 mb-2 ml-2 mr-2" color="#c42111" small fab :disabled="$props.lockSave || !selectedNodeBranch || !nodeClipboard" @click="pasteNode">
                        <v-icon style="transform: scaleX(-1);">mdi-content-paste</v-icon>
                    </v-btn>
                    <v-btn class="mt-2 mb-2 ml-2 mr-2" color="#c42111" small fab :disabled="$props.lockSave || !selectedNode || (selectedNode.node_id == -1)" @click="deleteNodeClick">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-col>

        <v-col cols="12" md="6">
            <v-card>
                <v-card-text>
                    <v-text-field outlined label="Node Name" color="#c42111" :disabled="selectedNode.node_id == -1 || $props.lockSave" v-model="selectedNode.node_name" v-if="selectedNode"></v-text-field>
                    <v-textarea outlined label="Description" color="#c42111" :disabled="selectedNode.node_id == -1 || $props.lockSave" v-model="selectedNode.node_description" v-if="selectedNode"/>

                    <p v-if="selectedNodeLeaf">Line Height</p>
                    <v-btn-toggle group mandatory v-model="selectedNode.node_line_height" v-if="selectedNodeLeaf">
                        <v-btn color="#c42111" :disabled="true" style="display: none;"></v-btn>
                        <v-btn color="#c42111" :disabled="$props.lockSave">1</v-btn>
                        <v-btn color="#c42111" :disabled="$props.lockSave">2</v-btn>
                        <v-btn color="#c42111" :disabled="$props.lockSave">3</v-btn>
                        <v-btn color="#c42111" :disabled="$props.lockSave">4</v-btn>
                        <v-btn color="#c42111" :disabled="$props.lockSave">5</v-btn>
                        <v-btn color="#c42111" :disabled="$props.lockSave">6</v-btn>
                    </v-btn-toggle>
                    
                    <!-- This is for when nothing is selected -->
                    <v-text-field outlined label="Node Name" color="#c42111" :disabled="true" v-if="!selectedNode"></v-text-field>
                    <v-textarea outlined label="Description" color="#c42111" :disabled="true" v-if="!selectedNode"/>
                </v-card-text>
            </v-card>
            <v-btn class="mt-2 mr-2" color="#c42111" :disabled="!$store.state.isDirty" @click="$emit('save', deletedNodes)">Save</v-btn>
            <v-btn class="mt-2 mr-2" color="#c42111" @click="$emit('cancel')">Cancel</v-btn>
        </v-col>

        </v-row>
    </v-container>
    </div>
</template>

<script>
export default {
  name: 'TreeStructure',
  props: ['tree', 'lockSave'],
  components: {

  },
  data: () => ({
    formValid: true,
    validation: {
        required: (value) => (value ? true : false || "Required field")
    },
    selectedNodes: [],
    openNodes: [],
    openNodesDead: [],
    deletedNodes: [],
    nodeClipboard: null
  }),

  computed: {
      selectedNode: function() {
          if(this.selectedNodes.length) {
              return this.selectedNodes[0];
          }
          return null;
      },

      selectedNodeParent: function() {
          if(this.selectedNode && this.selectedNode.node_id != -1) {
              return this.searchTree(this.$props.tree.tree_structure, this.selectedNode.parent_node_id);
          }
          return null;
      },

      selectedNodeBranch: function() {
          if(this.selectedNode) {
              if(this.selectedNode.node_line_height == 0) {
                  return true;
              }
          }
          return false;
      },

      selectedNodeLeaf: function() {
          if(this.selectedNode) {
              if(this.selectedNode.node_line_height >= 1) {
                  return true;
              }
          }
          return false;
      },

      isTop: function() {
          if(this.selectedNode) {
              return (this.selectedNode.node_order == 1);
          }
          return false;
      },

      isBottom: function() {
          if(this.selectedNodeParent) {
              return (this.selectedNode.node_order == this.selectedNodeParent.children.length);
          }
          return false;
      }
  },

  methods: {
    saveClick: function() {
        if(this.$refs.treeForm.validate()) {
            this.$emit('save', this.$props.tree);
        }
    },

    addBranch: function() {
        this.openParentBranch();

        let len = this.selectedNode.children.length;
        let id = this.$props.tree.next_node_id;
        let branch = {
            children: [
                {
                    children: [],
                    node_description: '',
                    node_name: 'New Leaf',
                    node_id: (id + 1),
                    node_line_height: 1,
                    node_order: 1,
                    parent_node_id: id,
                    tree_id: this.$props.tree.tree_id
                }
            ],
            node_description: '',
            node_name: 'New Branch',
            node_id: id,
            node_line_height: 0,
            node_order: (len + 1),
            parent_node_id: this.selectedNode.node_id,
            tree_id: this.$props.tree.tree_id

        };
        this.selectedNode.children.push(branch);
        this.$props.tree.next_node_id += 2;
        // Open the branch we just added
        this.openNodesDead.push(branch);
        this.openNodes = this.openNodesDead;
        // Set the selected node to new branch
        this.selectedNodes = [branch];
    },

    addLeaf: function() {
        this.openParentBranch();
        let len = this.selectedNode.children.length;
        let id = this.$props.tree.next_node_id;
        let leaf = {
            children: [],
            node_description: '',
            node_name: 'New Leaf',
            node_id: id,
            node_line_height: 1,
            node_order: (len + 1),
            parent_node_id: this.selectedNode.node_id,
            tree_id: this.$props.tree.tree_id
        };
        this.selectedNode.children.push(leaf);
        this.$props.tree.next_node_id += 1;
        // Apply open branches
        this.openNodes = this.openNodesDead;
        // Set the selected node to new leaf
        this.selectedNodes = [leaf];
    },

    moveUp: function() {
        this.swapFields(this.selectedNodeParent.children, (this.selectedNode.node_order - 1), (this.selectedNode.node_order - 2));
    },

    moveDown: function() {
        this.swapFields(this.selectedNodeParent.children, (this.selectedNode.node_order - 1), (this.selectedNode.node_order));
    },

    deleteNodeClick: function() {
        let type = (this.selectedNodeBranch ? 'Branch' : 'Leaf');
        let ltype = type.toLowerCase();
        this.$store.commit('showConfirmModal', {
            title: `Delete Tree ${type}?`,
            message: `This operation will delete this ${ltype}, and remove this ${ltype} from all sites. Are you sure you want to do this?`,
            type: 'delete',
            hideCancel: false,
            confirmAction: () => this.deleteNode()
        });
    },

    deleteNode: function() {
        let id = this.selectedNode.node_id;
        let removedOrder = this.selectedNode.node_order;

        // add node to deleted list
        this.deletedNodes.push({
            node_id: id,
            tree_id: -1,
            parent_node_id: -2,
            node_name: '',
            node_description: '',
            node_line_height: -1,
            node_order: -1
        });        

        // remove node from parent
        this.selectedNodeParent.children.splice(this.selectedNodeParent.children.indexOf(this.selectedNode), 1);

        // reconstruct the node order numbers
        for(const [idx, n] of this.selectedNodeParent.children.entries()) {
            n.node_order = (idx + 1);
        }

        // select the parent
        this.selectedNodes = [this.selectedNodeParent];
    },

    searchTree: function(node, searchId) {
        if(node.node_id == searchId) {
          return node;
        } 
        else if (node.children != null) {
            let i;
            let result = null;
            for(i=0; result == null && i < node.children.length; i++){
                result = this.searchTree(node.children[i], searchId);
            }
            return result;
        }
        return null;
    },

    swapFields: function(list, idx1, idx2) {
        let temp = list[idx1];
        list[idx1] = list[idx2];
        list[idx2] = temp;
        for(const [idx, n] of list.entries()) {
            n.node_order = (idx + 1);
        }
        // trigger refresh
        list.splice(0, 0);
    },

    openedBranch: function(arr) {
        // This is a hack to maintain a list of open brnaches. The veutify 'open.sync' tree prop has a bug that causes page to shit pants.
        this.openNodesDead = arr;
    },

    openParentBranch: function() {
        // This is a hack to maintain a list of open brnaches including the newly added node. 
        // The veutify 'open.sync' tree prop has a bug that causes page to shit pants.
        let currentBranchId = this.selectedNode.node_id;
        if(!this.openNodesDead.some(n => {
            return n.node_id == currentBranchId;
        })) {
            this.openNodesDead.push(this.selectedNodes[0]);
        }
    },

    copyNode: function() {
        this.nodeClipboard = JSON.parse(JSON.stringify(this.selectedNode));
    },

    getNextNodeId: function() {
        let id = this.$props.tree.next_node_id;
        this.$props.tree.next_node_id += 1;
        return id;
    },

    pasteNode: function() {
        console.log('PASTE NODE: ', this.nodeClipboard);
        console.log('TO THIS BRANCH: ', this.selectedNode);

        // Cant just do this because need to create new IDs and set correct parent IDs
        this.selectedNode.children.push(this.nodeClipboard);
        let root = this.nodeClipboard;
        // So lets use recursion to set those IDs now.
        let self = this;
        let setNodeIdsRecur = function(node, parent_id) {
            node.node_id = self.getNextNodeId();
            node.parent_node_id = parent_id;
            for(let n of node.children) {
                setNodeIdsRecur(n, node.node_id);
            }
        }
        setNodeIdsRecur(root, this.selectedNode.node_id);
        this.nodeClipboard = null;
    }

  },

  watch: {
    tree: {
        handler(newVal, oldVal) {
            if(!this.$props.lockSave) {
                this.$store.commit('setIsDirty', true);
            }
            //this.gridOptions.api.setRowData(this.$props.fieldsList);
        },
        deep: true
    }
  },

  mounted() {
      this.openNodes.push(this.$props.tree.tree_structure);
  }

  
};
</script>

<style scoped>

    .tree-body {
        overflow-y: auto;
        max-height: calc(100vh - 215px);
        height: calc(100vh - 215px);
    }

</style>
